<template>
    <span v-if="countryCode">
        <img class="country-display" :style="'width:'+imageWidth" :src="imagePath" @error="imageError()">
    </span>
</template>

<script>
import countriesJson from '@/assets/data/countries.json'

export default {
    props: [
        'countryCode',
        'size'
    ],
    data () {
        return {
            countries: countriesJson,
            imageWidth: "16px",
            showImage: true
        }
    },
    created(){
        if(this.size)
            this.imageWidth = this.size+'px';
    },
    methods: {
        imageError () {
            this.showImage = false
        }
    },
    beforeMount () {
        // this.displayBelt();
    },
    computed: {
        imagePath () {
            return this.assets()+'/flags/' + (this.countryCode ? this.countryCode.toUpperCase() : 'US')+ '.png'
        }
    }
}
</script>

<style scoped>
    .country-display {
        vertical-align: middle;
    }
</style>
